import {DropdownItem} from 'platform/components';
import {Show} from 'platform/foundation';

import i18n from '@dms/i18n';
import {myProfileRoutes} from '@dms/routes';

import {useNavigate} from 'shared/web';

import {AbsenceCard} from './AbsenceCard';
import {AvailabilityStatusDot} from './AvailabilityStatusDot';
import {PlannedAbsenceBanner} from './PlannedAbsenceBanner';
import {useAvailabilityStatus} from './useAvailabilityStatus';

interface AvailabilityStatusMenuProps {
  /** Closes the dropdown the menu sits in, before it navigates away. */
  onClose: VoidFunction;
}

/** Available / Away items plus the current or planned absence, inside a top-bar dropdown. */
export function AvailabilityStatusMenu(props: AvailabilityStatusMenuProps) {
  const navigate = useNavigate();

  const {status, activeAbsence, plannedAbsence, isMutating, setAway, returnEarly} =
    useAvailabilityStatus();

  const isAbsent = status === 'absent';

  const handleManage = () => {
    props.onClose();
    navigate(myProfileRoutes.userAbsence);
  };

  return (
    <>
      <DropdownItem
        label={i18n.t('user.awayStatus.available')}
        prefix={<AvailabilityStatusDot status="available" />}
        isActive={status === 'available'}
        isDisabled={isAbsent || isMutating}
        onClick={() => setAway(false)}
        data-testid="availabilityStatusSelect-available"
      />
      <DropdownItem
        label={i18n.t('user.awayStatus.away')}
        prefix={<AvailabilityStatusDot status="away" />}
        isActive={status === 'away'}
        isDisabled={isAbsent || isMutating}
        onClick={() => setAway(true)}
        data-testid="availabilityStatusSelect-away"
      />

      <Show when={isAbsent}>
        <AbsenceCard
          absence={activeAbsence}
          isReturning={isMutating}
          onReturnEarly={returnEarly}
          onManage={handleManage}
        />
      </Show>

      <Show when={!isAbsent}>
        <PlannedAbsenceBanner absence={plannedAbsence} />
      </Show>
    </>
  );
}
